import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { markdownToHtmlDeep } from "~/utils/markdownToHtml";

import en from "./en.json";
import fr from "./fr.json";

// The server sets <html lang> from the saved locale, which can lag behind the
// language detected here
i18n.on("languageChanged", () => {
  // No resolved language for the cimode and dev debug languages
  if (typeof document === "undefined" || !i18n.resolvedLanguage) return;
  document.documentElement.lang = i18n.resolvedLanguage;
});

// Locale files are written in Markdown; translations are converted once at
// boot so `t()` and `<Trans>` always hand out HTML. Conversion happens before
// interpolation, so an interpolated value can never turn into markup.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: markdownToHtmlDeep(en),
      },
      fr: {
        translation: markdownToHtmlDeep(fr),
      },
    },
    detection: {
      order: ["querystring", "navigator"],
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      // Tags markdownToHtml emits, so <Trans> renders them instead of
      // printing them. Links still need the <0> placeholder pattern: <Trans>
      // drops attributes, and an <a> without its href renders as plain text.
      transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "b",
        "i",
        "em",
        "s",
        "del",
        "u",
        "code",
        "p",
      ],
    },
  });

export default i18n;
